export default __webpack_public_path__ + "static/media/1.940a77f0.jpg";